import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ChangePassword from "@/pages/ChangePassword";

// Blocks all app features until an admin-provisioned / reset user changes their temporary password.
export default function PasswordGate() {
  const { user } = useAuth();
  if (user && user.must_change_password) return <ChangePassword forced />;
  return <Layout />;
}
